var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M152 224H72v-72C72 68.2 140.2 0 224 0s152 68.2 152 152v72h-80v-72a72 72 0 0 0-144 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M448 272v192a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V272a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48z","className":"fa-primary","key":2})]);
}

Lock.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Lock;

Lock.default = Lock;
